import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GradeDetails } from 'src/app/domain';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-dropdown-field',
    templateUrl: 'dropdown-field.component.html',
    styleUrls: ['dropdown-field.component.scss'],
    imports: [IonicModule, FormsModule]
})
export class DropdownFieldComponent {
  @Input() selectedGrade: string;
  @Input() gradeList: GradeDetails[];
  @Input() validGrades: boolean;
  @Input() dropdownTitle = 'Select your grade.';
  @Output() selectedValue = new EventEmitter<string>();

  constructor() {}

  valueSelected(name): void {
    this.selectedValue.emit(name);
  }
}
